import { createFragment } from "@applant/fragment-scripts/fragment";
import './index.scss';

const { init } = createFragment();

export { init };